export default __webpack_public_path__ + "static/media/35.166a735b.png";